import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Layout } from './components/Layout';
import Reports from './components/Reports';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import ReportDetails from './components/ReportDetails';
import Schedule from './components/Schedule';
import ScheduleDetails from './components/ScheduleDetails';
import ScheduleAdd from './components/ScheduleAdd';
import Help from './components/Help';
import Loading from './components/Loading';
import UserManagement from './components/UserManagement';
import UserDetails from './components/UserDetails';
import ChangePassword from './components/ChangePassword';
import ForgotPassword from './components/ForgotPassword';
import ConfirmRegistration from './components/ConfirmRegistration';
import ResetPassword from './components/ResetPassword';
import ReactGA from 'react-ga4';
import LoginHelp from './components/LoginHelp';
import NotFound from './components/NotFound';
import Print from './components/Print';
import FedAuth from './components/FedAuth';
import EnterpriseLogin from './components/EnterpriseLogin';
import PrivateExpiredRoute from './components/PrivateExpiredRoute';
import Settings from './components/Settings';
import AdminSettings from './components/AdminSettings';
import UpgradeToModernAccount from './components/UpgradeToModernAccount';
import Auth from './services/auth';
import CodingUpload from './components/CodingUpload';
import DocumentUpload from './components/DocumentUploadView';
import TranscriptionUploadView from './components/TranscriptionUploadView';
import DocumentArchiveRequest from './Pages/SupportRequestForm/SupportRequestForm';
import DistributionsManager from './components/DistributionsManager';

const auth = new Auth();

function CreateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


//uncomment this for debugging
ReactGA.initialize('G-QCWGVE33LE', { debug: true });

const logPageView = () => {

    ReactGA.set({ page: window.location.pathname });
    //custom dimension, selected account
    ReactGA.set({ account: auth.getActiveAccount() });
    //ReactGA.pageview(window.location.pathname);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    return null;
};

export default class App extends Component {
    displayName = App.name

    render() {
        return (
            <Layout>
                <Route component={logPageView} />
                <Switch>
                    <PrivateRoute exact path='/' component={Dashboard} />
                    <PrivateRoute exact path='/reports/search/:searchTerm' component={Reports} />
                    <PrivateRoute exact path='/reports/:status?/:dateType?' component={Reports} />
                    <PrivateRoute exact path='/schedule/:status?' component={Schedule} />
                    <PrivateRoute exact path='/reportdetails/:account/:jobid/:mode?' component={ReportDetails} />
                    <PrivateRoute exact path='/scheduledetails/:account/:patientListId' component={ScheduleDetails} />
                    <PrivateRoute exact path='/scheduleadd' component={ScheduleAdd} />
                    <PrivateRoute exact path='/settings' component={Settings} />
                    <PrivateRoute exact path='/admin' component={AdminSettings} />
                    <PrivateRoute exact path='/document-upload' component={DocumentUpload} />
                    <PrivateRoute exact path='/transcription-upload' component={TranscriptionUploadView} />
                    <PrivateRoute exact path='/support-request/:category?' component={DocumentArchiveRequest} />
                    <Route path='/login/:classic?' component={Login} />
                    <Route path='/loading' component={Loading} />
                    <Route path='/forgotpassword' component={ForgotPassword} />
                    <Route exact path='/confirmregistration/:code' component={ConfirmRegistration} />
                    <PrivateRoute exact path='/Users' component={UserManagement} />
                    <PrivateRoute exact path='/userdetails/:account/:userId' component={UserDetails} />
                    <PrivateRoute exact path='/help' component={Help} />
                    <PrivateExpiredRoute exact path='/ChangePassword' component={ChangePassword} />
                    <Route exact path='/resetPassword/:code' component={ResetPassword} />
                    <Route path='/loginHelp' component={LoginHelp} />
                    <PrivateRoute path='/print/:printKey' component={Print}/>
                    <Route path='/fedAuth' component={FedAuth} />
                    <Route path='/enterpriselogin' component={EnterpriseLogin} />
                    <Route path='/upgradetomodernaccount' component={UpgradeToModernAccount} />
                    <PrivateRoute exact path='/distributions' component={DistributionsManager} />
                    <Route component={NotFound} />
                </Switch>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js